import React from 'react'
import { useSelector } from 'react-redux'
import MediumInfoBlock from '../Data/MediumInfoBlock'
import './ContentImpression.css'
import emptyStateIcon from '../Icons/empty-state-icon.svg'

const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  if (hours > 0) {
    return `${hours} hours ${minutes} min`
  } else if (minutes > 0) {
    return `${minutes} min ${secs} sec`
  } else {
    return `${secs} sec`
  }
}

const formatDate = (milliseconds) => {
  const date = new Date(milliseconds)
  return date.toLocaleString('en-US', {
    weekday: 'short', // Change to short for 3-letter weekday
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })
}

const ContentImpression = () => {
  const { loading, data } = useSelector((state) => state.contentImpression)

  if (loading) {
    return <div className='loader'></div>
  }

  if (!data || data.length === 0) {
    return (
      <div className='empty-state-card'>
        <div className='empty-state-content'>
          <img src={emptyStateIcon} alt='No Data' className='empty-state-icon' />
          <h3 className='empty-state-title'>No Impression Data Available</h3>
          <p className='empty-state-message'>We couldn&apos;t find any impression data for the selected filters. Try adjusting your filters or check back later.</p>
        </div>
      </div>
    )
  }

  return (
    <div className=''>
      {data.map((item) => (
        <div key={item.entityId} className='' style={{ flex: '1 1', display: 'flex' }}>
            <div className='firstColGrid'>
                <div>
                <MediumInfoBlock
                    title='Total Impressions'
                    value={item.totalImpressions}
                    sinceText=''
                />
                </div>
                <div>
                    <MediumInfoBlock
                        title='Dwell Time'
                        value={formatTime(item.totalDwellTime)}
                        sinceText=''
                        fontSmall
                    />
                </div>
            </div>
            <div className='secondColGrid'>
                <MediumInfoBlock
                    title='Unique Impressions'
                    value={item.uniqueImpressions}
                    sinceText=''
                />
                <MediumInfoBlock
                    title='Latest Impression'
                    value={formatDate(Number(item.latestImpression))}
                    sinceText=''
                    fontSmall
                />
            </div>
        </div>
      ))}
    </div>
  )
}

export default ContentImpression
